import { CmObjectType } from '@svta/cml-cta'

/**
 * Common Media Client Data Object Type
 *
 *
 * @beta
 *
 * @enum
 */
export const CmcdObjectType = CmObjectType as typeof CmObjectType

/**
 * @beta
 */
export type CmcdObjectType = CmObjectType;
